<div class="backspinner" *ngIf="mode === 'indeterminate'">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<section class="payment-wrapper">
    <div class="container">
        <div class="pc-details d-flex justify-content-between flex-wrap">
            <div class="payment-details hideOnMobile">
                <img src="assets/images/stepper-banner.jpg" alt="image" />
            </div>
            <div class="payment-banner plan-pricedetails">
                <div class="subs-details">
                    <h2 class="servey-title show">
                        Diabetes Prevention & Management
                    </h2>
                    <ul class="list-details">
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Access to the MyLifeWell all-in-one app
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            12-week CDC-approved course
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            2 full recipe eBooks
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Diabetes FAQ eBook by Certified Coach
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            3 bonus courses designed to help with
                            daily movement, nutrition & mindfulness
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Bi-weekly email newsletter with tips,
                            tricks and guided app tours
                        </li>
                    </ul>
                </div>
                <div class="subsform">
                    <h2 class="servey-title form-title">
                        It's nice to meet you! Let's get started.
                    </h2>
                    <span *ngIf="dpmMsg != ''" style="color: red;">{{dpmMsg}}</span>
                    <form id="lead-create-account" [formGroup]="dpmForm">
                        <div class="form-group">
                            <input formControlName="firstName" class="form-control" type="text"
                                placeholder="First Name*">
                            <div *ngIf="submittedDPM && n.firstName.errors" class="invalid-feedback">
                                <div *ngIf="n.firstName.errors.required">First Name is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="lastName" class="form-control" type="text" placeholder="Last Name*">
                            <div *ngIf="submittedDPM && n.lastName.errors" class="invalid-feedback">
                                <div *ngIf="n.lastName.errors.required">Last Name is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="dpmEmail" class="form-control" type="email"
                                placeholder="Email Address*">
                            <div *ngIf="submittedDPM && n.dpmEmail.errors" class="invalid-feedback">
                                <div *ngIf="n.dpmEmail.errors.required">Email is required</div>
                                <div *ngIf="n.dpmEmail.errors.email">Email must be a valid email address</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="dpmPassword" class="form-control" type="password" autocomplete
                                placeholder="Password*">
                            <div *ngIf="submittedDPM && n.dpmPassword.errors" class="invalid-feedback">
                                <div *ngIf="n.dpmPassword.errors.required">Password is required</div>
                                <div *ngIf="n.dpmPassword.errors.minlength">Password must be at least 6
                                    characters
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <input formControlName="dpmConfirmPassword" class="form-control" type="password"
                                autocomplete placeholder="Confirm Password*">
                            <div *ngIf="submittedDPM && n.dpmConfirmPassword.errors" class="invalid-feedback">
                                <div *ngIf="n.dpmConfirmPassword.errors.required">Password is required</div>
                            </div>
                        </div>

                        <a class="btn login-btn strted-btn" (click)="submitDPM()">
                            <span>
                                Get Started
                            </span>
                        </a>
                    </form>
                    <div>
                        <span style="margin: 5px;">Already a MyLifeWell.com member?
                            <span class="cursorHand fontWt600">
                                Log In
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>